module.exports = __webpack_public_path__ + "img/bilaterale_sx.9c442d99.png";